import React from 'react';
import { BRAND, isMarketGB } from '../../constants/main';
import { StockModelListStyledAC } from './AC/StockModelListStyled.AC';
import { StockModelListStyledAP } from './AP/StockModelListStyled.AP';
import { StockModelListStyledDS } from './DS/StockModelListStyled.DS';
import { StockModelListStyledOV } from './OV/StockModelListStyled.OV';
import { StockModelListStyledOVGB } from './OV/StockModelListStyled.OVGB';
import { StockModelListStyled } from './StockModelListStyled';

import { SC } from '../../styles/theme';
import { IVehicleTransformed } from '../../services/stock/models/stockItems.service.model';
import { BrandTypes } from '../../types/brands';

export type StockModelListProps = SC & {
    vehicleList: Array<IVehicleTransformed>;
    vehicleOutList: Array<IVehicleTransformed>;
    showLastItemBanner?: boolean;
};

const StockModelList = (props: StockModelListProps) => {
    if (BRAND === BrandTypes.AC) return <StockModelListStyledAC {...props} />;
    if (BRAND === BrandTypes.OV)
        return isMarketGB ? <StockModelListStyledOVGB {...props} /> : <StockModelListStyledOV {...props} />;
    if (BRAND === BrandTypes.AP) return <StockModelListStyledAP {...props} />;
    if (BRAND === BrandTypes.DS) return <StockModelListStyledDS {...props} />;
    return <StockModelListStyled {...props} />;
};

export default StockModelList;
